import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link, ListItemText, MenuItem, ListItemIcon } from '@mui/material';

import { useMediaTableContext } from '@src/hooks/contexts';
import { usePostDownloadData } from '@src/hooks';
import { useVpSnackbar } from '@vp-ui/hooks';
import VpInfoMenuItem from '@vp-ui/components/VpInfoMenu/VpInfoMenuItem';
import { VpIcon } from '@vp-ui';
import { VpInfoMenu } from '@vp-ui/components';

const VpSubmissionInfoMenu = ({ submission, canDownload }) => {
  const menuItems = useMemo(() => {
    const options = [
      ...(canDownload
        ? [
            {
              id: 'download',
              label: 'Download',
              icon: 'DownloadCloud',
            },
          ]
        : []),
      {
        id: 'delete',
        label: 'Delete',
        icon: 'Trash2',
        variant: 'error',
      },
    ];
    return options;
  }, [canDownload]);

  const { mutate: downloadMutation, isLoading, isSuccess } = usePostDownloadData();
  const { setSelectedEntity } = useMediaTableContext();
  const { addSnackbarSuccess } = useVpSnackbar();

  useEffect(() => {
    if (isSuccess) {
      addSnackbarSuccess({
        message: `Your download is In Progress! We'll email you as soon as it's done!`,
      });
    }
  }, [isSuccess]);

  const onSelect = (item) => {
    switch (item?.id) {
      case 'download': {
        const data = {
          mediaIds: submission?.videoContent.map((media) => media?.mediaId),
          attachmentIds: submission?.attachmentsContent.map((att) => att?.attachmentId),
        };
        downloadMutation({ data });
        return;
      }
      case 'delete': {
        setSelectedEntity(submission);
        return;
      }
    }
  };

  return (
    <VpInfoMenu
      id={submission?.campaignSubmissionId}
      menuItems={menuItems}
      loading={isLoading}
      onSelect={onSelect}
    >
      <Link
        onClick={(e) => {
          e.stopPropagation();
        }}
        href={`https://app.videopeel.com/cs/${submission?.campaignSubmissionId}`}
        sx={{
          color: 'vpColors.greyDark',
          textDecoration: 'none',
          ':hover': {
            textDecoration: 'none',
            color: 'vpColors.greyDark',
          },
        }}
        target="_blank"
      >
        <MenuItem>
          <ListItemIcon>
            <VpIcon icon="Link2" />
          </ListItemIcon>
          <ListItemText>Public Submission Page</ListItemText>
        </MenuItem>
      </Link>

      {menuItems.map((item) => (
        <VpInfoMenuItem
          key={item?.id}
          item={item}
          onSelect={onSelect}
          disabled={item?.disabled}
          conditionalProps={item?.conditionalProps}
        />
      ))}
    </VpInfoMenu>
  );
};

VpSubmissionInfoMenu.propTypes = {
  submission: PropTypes.object,
  canDownload: PropTypes.bool,
};

export default VpSubmissionInfoMenu;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpSubmissionInfoMenu.jsx